import React, { useEffect, useState } from "react";
import {} from "../../../Redux/Actions/actions";
import { BaseUrl, PortalUrl } from "../../../Container/BaseUrl/BaseUrl";
import axios from "axios";
import { connect } from "react-redux";

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};
const CrmComponent = (props) => {
  const [link, setLink] = useState(``);

  const CrmScreenpopupApi = async () => {
  let body;

  if (
   props.externalChatData
        ? props.externalChatData.channel == "voice" &&
          (localStorage.getItem("type") === "sales" ||
            localStorage.getItem("type") === "service")
        : ""
  ) {
    body = {
      phonenumber: props.externalChatData.phonenumber,
      skillset: props.externalChatData.skillset,
      channel: props.externalChatData.channel,
      type: localStorage.getItem("type"),
      reg_no: localStorage.getItem("Contactreg_no"),
      contact_id: localStorage.getItem("ContactVoiceId"),
    };
  } else {
    body = {
      phonenumber: props.externalChatData.phonenumber,
      skillset: props.externalChatData.skillset,
      channel: props.externalChatData.channel,
      direction:
        props.externalChatData.direction === "Inbound"
          ? "INBOUND"
          : "OUTBOUND",
      contactid: props.externalChatData.voice_contactId
        ? props.externalChatData.voice_contactId
        : "",
    };
  }

  try {
    const res = await axios.post(
      `${PortalUrl}/v1/purple/screenpopup`,
      body,
      {
        headers: {
          Authorization: "Bearer " + localStorage.getItem("access_token"),
          "Content-Type": "application/json",
          tenantid: localStorage.getItem("TenantId"),
        },
      }
    );

    if (res.data && res.data.data) {
      window.open(res.data.data, "_blank");
    } else {
      console.warn("No URL returned from CRM API", res.data);
    }
  } catch (err) {
    console.error("CRM screenpop API error:", err);
  }
};

  useEffect(() => {
    CrmScreenpopupApi();
  }, []);
  return (
    <div className="d-flex justify-content-center h-100 w-100">
      <iframe src={link} style={{ width: "100vw", height: "90vh" }}></iframe>
    </div>
  );
};

export default connect(mapStateToProps, {})(CrmComponent);
